module.exports = __webpack_public_path__ + "static/img/11.6506652.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/sp/11.png
// module id = Egk+
// module chunks = 0